export default function productsSliderSync() {
    if ($('.js-slider-products-store').length) {
        let $sliderProducts = $('.js-slider-products-store').find('.js-store-product');

        $sliderProducts.map(function(el) {
            let $item = $($sliderProducts[el]);
            let itemId = $item.data('product-id');
            let itemInFavorite = $item.find('.js-to-favorite').hasClass('_in-favorite');
            let itemInBasket = $item.find('.js-to-basket').hasClass('_in-basket-btn');
            let itemQuantity = itemInBasket ? $item.find('.js-quantity-input').val() : 0;
            let itemQuantityMax = itemInBasket && $item.find('.js-quantity-input').data('max') ? $item.find('.js-quantity-input').data('max') : 9999;

            let $currProduct = $('.content').find(('.js-store-product[data-product-id="' + itemId + '"]'));
            let $currProductInput = $currProduct.find('.js-quantity-input');

            if (itemInFavorite) {
                $currProduct.find('.js-to-favorite').addClass('_in-favorite');
            }

            if (itemInBasket) {
                $currProduct.find('.js-product-item-bottom').addClass('_in-basket');
                $currProduct.find('.js-to-basket').addClass('_in-basket-btn');
                $currProductInput.val(itemQuantity);

                if (parseInt(itemQuantity) != 1 && parseInt(itemQuantity) >= parseInt(itemQuantityMax)) {
                    $currProductInput.val(itemQuantityMax);
                    $currProduct.find('.js-quantity-plus').addClass('_disabled');
                }
            }
        });
    }
};

